import { gql } from "@apollo/client";

export const DELETE_TEMPLATE = gql`
  mutation deleteTemplate($templateId: String!, $clientIdentifier: String) {
    invoiceInterpretation {
      deleteTemplate(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
      ) {
        success
      }
    }
  }
`;
